import { merge, get, pullAllWith, isArray, cloneDeep, includes } from 'lodash';
import Config from 'config/Config';
import { dropByCacheKey } from 'react-router-cache-route';

export default class routerCache {
  static config = {
    ...get(Config, 'routerCache', {}),
    cacheQueue: [],//已缓存队列
  }
  /**
   * 修改路由配置
   * @param data {object} 需要修改的值
  */
  static setConfig(data) {
    this.config = merge(this.config, data);
  }
  /**
   * 处理路由名的第一个斜杠 /
  */
  static urlName(pathname = '') {
    if (pathname[0] == '/') {
      return pathname.substring(1, pathname.length);
    } else {
      return pathname
    }
  }
  /**
   * 当前路由被访问时，添加路由到已缓存队列中
   * @param routerItem {object} 要保存的路由信息
   * @param routerItem.pathname {string} 要保存的路由信息
   * @param routerItem.search {string} 要保存的路由参数信息
  */
  static addCache(routerItem) {
    //当前路由包含在缓存列表中
    if (this.notFound(get(routerItem, 'pathname'))) {
      //已缓存队列
      let cacheQueue = cloneDeep(get(this.config, 'cacheQueue', []));
      //如果已缓存队列大于最大缓存长度，则删除队列后面的缓存
      if (isArray(cacheQueue) && cacheQueue.length >= get(this.config, 'cacheLength')) {
        cacheQueue = this.deleteCache(get(cacheQueue[0], 'pathname'));
      }
      if (isArray(cacheQueue)) cacheQueue.push(routerItem);
      this.setConfig({ cacheQueue: cacheQueue });
    }
  }
  static dropByCacheKey(url) {
    dropByCacheKey(this.urlName(url));
  }
  /**
   * 从缓存中删除某路由的缓存
   * @param pathname {string || array} 要删除的路由 和路由配置中的路由一致，但第一个字母不能带 '/'   
   *            如果pathname 等于  0   删除全部缓存
   * @return cacheQueue  返回筛除过后的已缓存列表
  */
  static deleteCache(pathname) {
    let delectArr = []; //要删除的路由
    //已缓存队列
    let cacheRouterList = get(this.config, 'cacheRouterList', []);
    let cacheQueue = get(this.config, 'cacheQueue', []);
    if (pathname == 0) {
      //删除所有路由
      if (cacheRouterList && isArray(cacheRouterList)) {
        cacheRouterList.map((item) => {
          this.dropByCacheKey(item.path);
          cacheQueue = [];
        });
      }
    } else if (isArray(pathname)) {
      pathname.map((item) => {
        this.dropByCacheKey(item);
        delectArr.push({ pathname: this.urlName(item) });
      });
    } else {
      delectArr.push({ pathname: this.urlName(pathname) });
      this.dropByCacheKey(pathname);
    }
    //从已缓存队列中，删除清空的路由，更新已缓存队列
    cacheQueue = cloneDeep(pullAllWith(cacheQueue, delectArr, (arrVal, othVal) => {
      if (this.urlName(get(arrVal, 'pathname')) == this.urlName(get(othVal, 'pathname'))) {
        return true;
      }
    }));
    this.setConfig({ cacheQueue: cacheQueue });
    return cacheQueue;
  }
  /**
   * 判断当前路由是否包含在缓存列表中，以此决定是否要显示404页面
   * @Param pathname {string} 当前路由
   * @return boole
  */
  static notFound(pathname) {
    let status = false;
    let cacheRouterList = get(this.config, 'cacheRouterList');
    if (cacheRouterList && isArray(cacheRouterList)) {
      cacheRouterList.map((item) => {
        if (this.urlName(get(item, 'path')) == this.urlName(pathname)) {
          status = true;
        }
      });
    }
    return status;
  }
  /**
   * 修改路由配置
   * @param list {array<object>} 路由列表
   * @return {routerList, cacheRouterList}   不需要缓存的路由，需要缓存的路由
  */
  static routerFactory(list = []) {
    let routerList = [],
      cacheRouterList = [];
    let { ruleOutCacheRouter, isStart } = this.config;
    if (isArray(list)) {
      if (isStart) {
        list.map((item) => {
          if (isArray(ruleOutCacheRouter) && ruleOutCacheRouter.includes(this.urlName(item.path))) {
            routerList.push(item);
          } else {
            cacheRouterList.push(item);
          }
        });
      } else {
        //如果没有开启缓存， 则返回全部路由
        routerList = list;
      }
    } else {
      console.error("路由地址必须为数组");
    }
    this.setConfig({ routerList, cacheRouterList });
    return { routerList, cacheRouterList }
  }
  /**
   * 从浏览 记录中对比访问参数，以此判断是否要清除缓存
   * @param location {string} props中的路由对象
  */
  static updateDeCache(location) {
    let updateDeCacheData = get(this.config, 'updateDeCache'); //需要对比的路由队列
    let cacheQueue = get(this.config, 'cacheQueue', []); //已缓存队列
    location = cloneDeep(location);
    let pathname = this.urlName(location.pathname);
    let isDe = () => {
      let state = false;
      cacheQueue.map((item) => {
        if (item.pathname == pathname) {
          state = item;
        }
      });
      return state;
    }
    if (isArray(updateDeCacheData)) {
      updateDeCacheData.map((item) => {
        //要跳转的路由，已经包含在需要对比的路由队列
        //并且，包含在已缓存的队列
        if (item == pathname && isDe()) {
          if (location.search != isDe().search) {
            this.deleteCache(pathname)
          }
        }
      });
    } else if (updateDeCacheData == true) {
      if (isDe()) {
        if (location.search != isDe().search) {
          this.deleteCache(pathname)
        }
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/utils/routerCache.js